import React, { useContext } from "react";
import freeShippingIcon from "../../assets/page icons/free shipping.png";
import freeTrialIcon from "../../assets/page icons/100 nights free trial.png";
import WarrantyIcon from "../../assets/page icons/15 years warranty.png";
import { AppContext } from "../../context/AppContext";
import icon_1 from "../../assets/icons/icon_1.png"
import icon_2 from "../../assets/icons/icon_2.png"
import icon_3 from "../../assets/icons/icon_3.png"
export default function BandIcons() {
  const { globalCategory } = useContext(AppContext);
  return (
    <div className={`${globalCategory === 'Eloris' ? 'bg-[#194083] text-[#f4e391]' : 'bg-[#226b2a] text-[#f4e390]'}  py-14`}>
      <div className="max-w-full xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto sm:px-5 md:px-0">
        <div className="grid grid-cols-3 gap-3 xl:gap-10">
          {/* ITEM 1 */}
          <div className="flex flex-col md:flex-row gap-3 md:gap-5 justify-center items-center text-left">
            <img
              src={globalCategory === 'Eloris' ? freeShippingIcon : icon_1}
              alt=""
              className="w-[80px] xl:w-auto mx-auto md:mx-0"
            />
            <p className="text-[12px] md:text-[22px] font-lexend uppercase font-semibold leading-tight">
              Free <br /> Shipping
            </p>
          </div>

          {/* ITEM 2 */}
          <div className="flex flex-col md:flex-row gap-3 md:gap-5 justify-center items-center text-left">
            <img
              src={globalCategory === 'Eloris' ? freeTrialIcon : icon_2}
              alt=""
              className="w-[50px] xl:w-auto mx-auto md:mx-0"
            />
            <p className="text-[12px] md:text-[22px] font-lexend uppercase font-semibold leading-tight">
              100 Nights <br /> Free Trial
            </p>
          </div>

          {/* ITEM 3 */}
          <div className="flex flex-col md:flex-row gap-3 md:gap-5 justify-center items-center text-left">
            <img
              src={globalCategory === 'Eloris' ? WarrantyIcon : icon_3}
              alt=""
              className="w-[50px] xl:w-auto mx-auto md:mx-0"
            />
            <p className="text-[12px] md:text-[22px] font-lexend uppercase font-semibold leading-tight">
              15 Years <br /> Warranty
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
